const Translation = {
  en: {
    title: "CAG – your digital AI assistant.",
    suggestedQuestionsText: "Suggested Questions",
    suggestedQuestions: [
      "I am an Audit Assistant posted in AG (Audit) Uttar Pradesh and my promotion to Senior Auditor is pending since July 2023. All my APARs are clear but my case is not being included in the DPC without any reason.",
      "After my transfer from AG Assam to AG Tamil Nadu in March 2024, my pay has not been fixed correctly. I am still getting my old basic pay and arrears are also pending. Multiple representations have been submitted but no correction has been done.",
      "I retired from IA&AD in December 2022 from AG (A&E) Maharashtra. My gratuity amount of around Rs. 12 lakhs is still not released without any clear reason. The office is not responding to emails or phone calls.",
    ],
    faqTitle: "Ask your query",
    faqScroller:
      "This assistant provides guidance and answers queries related to CAG services",
    botScroller:
      "This assistant provides a simple way to submit grievances and track status of previously submitted requests",
    suggestedFAQs: [
      "What is CAG?",
      "What powers does the CAG have?",
      "How does CAG perform his role?",
    ],
    searchPlaceholder:
      "Type your query here or press mic for audio communication",
    apiErrorMessage: "Sorry I cannot understand, please reframe the message.",
    grievanceInfo: `
        <div style="text-align:left; font-size:16px">
          1. RTI matters <br><br>
        2. Matters pending before any Court of Law or Tribunal (subjudice matters)<br><br>
        3. Religious matters<br><br>
        4. Grievances of Government employees concerning their service matters including disciplinary proceedings, unless the aggrieved employee has already exhausted the prescribed channels, keeping in view DoPT OM No.
        11013/08/2013-Estt.(A-III) dated 31.08.2015<br><br>
        5. Concerns or issues that are governed by departmental policies on audit, including matters relating to Inspection Reports (IR), Draft Paras (DP), and Audit Reports — such matters are not covered under the grievance redressal mechanism.
    
        </div>
      `,
  },

  hi: {
    title: "सीजीए - आपका डिजिटल AI सहायक।",
    suggestedQuestionsText: "सुझाए गए प्रश्न",
    suggestedQuestions: [
      "मैंने अपने आधार में पता बदलने के लिए आवेदन किया था। मैंने सभी वैध दस्तावेज़ जमा किए थे, फिर भी बिना किसी स्पष्टीकरण के मेरा आवेदन खारिज कर दिया गया। कृपया मेरी सहायता करें।",
      "मेरा PF अकाउंट डीएक्टिवेट दिखा रहा है। मैंने इस संबंध में अपने एम्प्लॉयर और चंडीगढ़ स्थित PF ऑफिस से संपर्क किया है, लेकिन मुझे कोई उचित समाधान नहीं मिल रहा है। कृपया मेरे PF अकाउंट को फिर से एक्टिवेट कर दें।",
      "मैं अपना नया बैंक खाता इनकम टैक्स पोर्टल पर जोड़ना चाहता हूं लेकिन इसका वेरिफिकेशन बार बार विफल हो रहा है, कृपया मेरी सहायता करें",
    ],
    faqTitle: "अपना प्रश्न पूछें",
    faqScroller:
      "यह सहायक सीएजी सेवाओं से संबंधित मार्गदर्शन प्रदान करता है और प्रश्नों के उत्तर देता है।",
    botScroller:
      "यह सहायक शिकायत दर्ज करने और पहले से जमा किए गए अनुरोधों की स्थिति की जांच करने का एक सरल तरीका प्रदान करता है।",
    suggestedFAQs: [
      "सीएजी कौन है?",
      "सीएजी के क्या अधिकार हैं?",
      "सीएजी अपनी भूमिका कैसे निभाता है?",
    ],
    searchPlaceholder:
      "अपना प्रश्न यहां लिखें या ऑडियो संचार के लिए माइक दबाएं",
    apiErrorMessage:
      "क्षमा करें मैं समझ नहीं पा रहा हूं, कृपया संदेश को फिर से तैयार करें।",
    grievanceInfo: `
        <div style="text-align:left">
          1. RTI matters <br><br>
        2. Matters pending before any Court of Law or Tribunal (subjudice matters)<br><br>
        3. Religious matters<br><br>
        4. Grievances of Government employees concerning their service matters including disciplinary proceedings, unless the aggrieved employee has already exhausted the prescribed channels, keeping in view DoPT OM No.
        11013/08/2013-Estt.(A-III) dated 31.08.2015<br><br>
        5. Concerns or issues that are governed by departmental policies on audit, including matters relating to Inspection Reports (IR), Draft Paras (DP), and Audit Reports — such matters are not covered under the grievance redressal mechanism.
    
        </div>
      `,
  },
};

export default Translation;
